module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am420-5de9d42d5725b7c200d742d5e30f49ef.jpg";